import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginForm from './components/Login/LoginComponent';
import Dashboard from './components/Dashboard/DashboardComponent';
import MasterSuppressionDashboard from './components/MasterSuppression/MasterSuppressionComponent';
import LogViewer from './components/MasterSuppression/LogMasterSuppressionComponent';
import routes from './routes/routes';

const App = () => {
  const token = localStorage.getItem('token');

  return (
    <Router>
      <Routes>
        <Route path={routes.LOGIN} element={<LoginForm />} />
        <Route path={routes.DASHBOARD} element={token ? <Dashboard /> : <Navigate to="/login" />} />
        <Route path={routes.MASTER_SUPPRESSION} element={token ? <MasterSuppressionDashboard /> : <Navigate to="/login" />} />
        <Route path={routes.MEGAN_SUPPRESSION} element={token ? <LogViewer /> : <Navigate to="/login" />} />
        <Route path={routes.HOME} element={token ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} /> {/* Default route */}
      </Routes>
    </Router>
  );
}

export default App;
